<template>
  <div v-if="story.publication_rules" class="m-10">
    <div class="m-b-40">
      <table class="table">
        <thead>
          <tr>
            <th>Clé</th>
            <th>Valeur</th>
          </tr>
        </thead>
        <tbody v-if="Object.keys(story.attachments_by_keys).length == 0">
          <tr>
            <td colspan="4" class="text-center">
              <em class="text-muted">
                Pas d’attributs spéciaux pour ce contenu
              </em>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr
            v-for="(attachment, key) in story.attachments_by_keys" :key="key">
            <td>
              {{ key || 'Non précisé' }}
            </td>
            <td>
              {{ attachment.value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <pre>{{ story.attachments_by_keys }}</pre> -->
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'story-attachments',
  computed: mapGetters({
    constants: 'constants',
    story: 'story'
  }),
  components: {},
  props: {
    parentInitFunction: Function,
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dirty: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {},
    updatePublicationRule (key, value, index) {
      let rules = JSON.parse(JSON.stringify(this.story.publication_rules))
      rules[index][key] = value
      this.$store.commit('UPDATE_STORY_VALUE', {
        publication_rules: rules
      })
    }
  }
}
</script>
<style>
</style>
